import { SmartTable } from '@certemy/ui-components';

export const DUE_DATE_RANGE_SMART_FILER_VALUE = {
  from: '',
  to: '',
};

export const DefaultSubscriptionDocumentsFilter = {
  page: 1,
  limit: 10,
  sortBy: `documentSourceDate:${SmartTable.Order.DESC}`,
  filters: {
    startDate: DUE_DATE_RANGE_SMART_FILER_VALUE.from,
    endDate: DUE_DATE_RANGE_SMART_FILER_VALUE.to,
  },
};
